import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogLoadingService } from './dialog-loading/dialog-loading.service';
import { LoadingService } from './loading.service';

export function provideLoadingDialog(): EnvironmentProviders {
  return makeEnvironmentProviders([
    MatDialogModule,
    MatProgressSpinnerModule,
    DialogLoadingService,
    {
      provide: LoadingService,
      useClass: DialogLoadingService,
    },
  ]);
}

export function injectLoadingService() {
  return inject(LoadingService);
}
